import {Injectable, Component} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/combineLatest";

interface Sample {
  foo: string;
}

@Injectable()
class SampleService {
  constructor(private http: Http) {
  }

  fetch(): Observable<Sample> {
    return this.http.get("data/data.json")
      .map(res => res.json() as Sample)
      .combineLatest(
      this.http.get("data/data2.json").map((res => res.json())),
      (data1: any, data2: any) => {
        data1.foo = data2.fizz;
        return data1;
      });
  }
}

@Component({
  selector: 'http-http',
  template: `
  <usecase-container title="Http" src="http/http">
    <usecase-content>
      <pre>{{ data | json }}</pre>
    </usecase-content>
  </usecase-container>
  `,
  providers: [SampleService]
})
export class HttpComponent {
  private data: Sample;

  constructor(private service: SampleService) {
  }

  ngOnInit() {
    this.service.fetch()
      .subscribe(
      data => {
        this.data = data;
      },
      error => {
        alert(error);
      }
      );
  }
}



/** WEBPACK FOOTER **
 ** ./script/http/http/component.ts
 **/